/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_P3dInputs */

const en_mk_sol_operasional_p3d = /** @type {(inputs: Mk_Sol_Operasional_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When something is questioned later, the trail is scattered across email and chat.`)
};

const id_mk_sol_operasional_p3d = /** @type {(inputs: Mk_Sol_Operasional_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketika ada yang dipertanyakan belakangan, jejaknya tersebar di email dan chat.`)
};

/**
* | output |
* | --- |
* | "When something is questioned later, the trail is scattered across email and chat." |
*
* @param {Mk_Sol_Operasional_P3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_p3d = /** @type {((inputs?: Mk_Sol_Operasional_P3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_P3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_p3d(inputs)
	return en_mk_sol_operasional_p3d(inputs)
});